import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemindMinusFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9063 14C15.4688 16.5 12.8438 18 10 18ZM7.75 9.25C7.3125 9.25 7 9.59375 7 10C7 10.4375 7.3125 10.75 7.75 10.75H12.25C12.6563 10.75 13 10.4375 13 10C13 9.59375 12.6563 9.25 12.25 9.25H7.75Z"
	})
});
const ForwardRef = forwardRef(SvgRemindMinusFilled);
export default ForwardRef;
